export const state = initialState();

export const actions = {
  changeTutorialMode: async ({ commit }, payload) => {
    commit('changeTutorialMode', payload);
  },

  changeTutorialMobile: async ({ commit }, payload) => {
    commit('changeTutorialMobile', payload);
  }
};

export const mutations = {
  changeTutorialMode: (state, payload) => {
    state.tutorialMode = payload;
  },
  changeTutorialMobile: (state, payload) => {
    state.mobile = payload;
  }
};

export const getters = {};

function initialState() {
  return {
    tutorialMode: false,
    mobile: false
  };
}
